export default __webpack_public_path__ + "static/media/heart.b65bcc72.svg";